import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_ALERT_CONFIG, fetchAlertConfigs } from "../actions";
import { selectAlertConfigs, selectRemainingAlertConfigs } from "../selectors";
import { Badge, Button } from "react-bootstrap";
import Modal from "./common/modal";
import { AlertConfigsTable } from "./alerts";
import { UpdateConfigForm } from "./alerts";
import { useAuthErrorHandler } from "../hooks";
import { makeOptionalAuthRequest } from "../http";

const useDeleteConfigModal = () => {
  const dispatch = useDispatch();
  const handleError = useAuthErrorHandler();
  const [configToDeleteId, setConfigToDeleteId] = useState();
  const clearConfigToDeleteId = useCallback(
    () => setConfigToDeleteId(undefined),
    [setConfigToDeleteId]
  );
  const deleteConfig = useCallback(async () => {
    try {
      await makeOptionalAuthRequest().delete(
        `/api/alert_configs/${configToDeleteId}`
      );
      dispatch({
        type: DELETE_ALERT_CONFIG,
        payload: configToDeleteId,
      });
      clearConfigToDeleteId();
    } catch (error) {
      handleError(error, () => setConfigToDeleteId(undefined));
    }
  }, [dispatch, configToDeleteId, setConfigToDeleteId, handleError]);

  return {
    configToDeleteId,
    setConfigToDeleteId,
    clearConfigToDeleteId,
    deleteConfig,
  };
};

export const AlertsPage = () => {
  const dispatch = useDispatch();
  const {
    configToDeleteId,
    setConfigToDeleteId,
    deleteConfig,
    clearConfigToDeleteId,
  } = useDeleteConfigModal();
  useEffect(() => {
    dispatch(fetchAlertConfigs());
  }, []);
  const alertConfigs = useSelector(selectAlertConfigs);
  const remaining = useSelector(selectRemainingAlertConfigs);
  const [selectedConfigId, setSelectedConfigId] = useState();
  const clearSelected = useCallback(() => setSelectedConfigId(undefined), [
    setSelectedConfigId,
  ]);

  if (alertConfigs == null) return <div>Loading...</div>;

  const selectedConfig = alertConfigs.find(
    (config) => config.id === selectedConfigId
  );
  const configToDelete = alertConfigs.find(
    (config) => config.id === configToDeleteId
  );

  return (
    <>
      {selectedConfig != null && (
        <Modal
          show
          onHide={clearSelected}
          title={`${selectedConfig.symbol} Alert`}
        >
          <UpdateConfigForm
            config={selectedConfig}
            onComplete={clearSelected}
          />
        </Modal>
      )}
      {configToDelete != null && (
        <Modal
          show
          onHide={clearConfigToDeleteId}
          title={`Remove ${configToDelete.symbol}`}
        >
          <div>
            <p>Are you sure you want to delete the alert?</p>
            <Button onClick={deleteConfig}>Delete</Button>
          </div>
        </Modal>
      )}
      <h4>
        Currently in beta, but when your alert criteria is triggered you will
        receive an email!
      </h4>
      <AlertConfigsTable
        configs={alertConfigs}
        onSelectConfig={setSelectedConfigId}
        onDeleteConfig={setConfigToDeleteId}
      />
      <p>
        Alerts Remaining: <Badge>{remaining}</Badge>
      </p>
      <p>
        Want more Alerts?{" "}
        <a href="https://www.patreon.com/iborrowdesk">Patrons</a> at the $1+ and
        $10+ level can monitor additional securities!
      </p>
    </>
  );
};
